import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import {
  CustomFieldsAPI,
  GetCustomFieldsQuery,
  GetCustomFieldsResponse,
} from "./custom-fields.api";
import { queryClient } from "@/index";
import { CUSTOM_FIELD_CATEGORIES } from "./custom-fields.types";

const customFieldsQueryKeys = {
  all: ["custom-fields", "list"],
  list: (query?: GetCustomFieldsQuery) => ["custom-fields", "list", query],
};

const useGetCustomFields = (
  query?: GetCustomFieldsQuery,
  options?: Omit<
    UseQueryOptions<GetCustomFieldsResponse, Error>,
    "queryKey" | "queryFn"
  >
) => {
  return useQuery({
    queryKey: customFieldsQueryKeys.list(query),
    queryFn: () => CustomFieldsAPI.get(query),
    ...options,
  });
};

const prefetchCustomFields = async () => {
  for (const category of Object.values(CUSTOM_FIELD_CATEGORIES)) {
    queryClient.prefetchQuery({
      queryKey: customFieldsQueryKeys.list({ category }),
      queryFn: () => CustomFieldsAPI.get({ category }),
    });
  }
};

export const CustomFieldsQuery = {
  queryKeys: customFieldsQueryKeys,
  useGetCustomFields,
  prefetchCustomFields,
};
